// Overall — cross-company pivot data.

export interface Company {
  id: string;
  name: string;
  short: string;
  cluster: string;
}

export interface PivotRow {
  name: string;
  level: number;
  total?: boolean;
  override?: string[];
  vals: Record<string, [number, number]>; // [calc, master]
}

export const COMPANIES: Company[] = [
  { id: 'dd', name: 'Delta Doors',       short: 'DD', cluster: 'dd_1q26' },
  { id: 'sd', name: 'Senim Doors',       short: 'SD', cluster: 'sd_1q26' },
  { id: 'kl', name: 'Kendala Logistics', short: 'KL', cluster: 'kl_1q26' },
  { id: 'ki', name: 'Kendala Impex',     short: 'KI', cluster: 'ki_1q26' },
  { id: 'dk', name: 'Двери.Класс',       short: 'DK', cluster: 'dk_1q26' },
  { id: 'cn', name: 'ЦН недвижимость',   short: 'CN', cluster: 'cn_1q26' },
];

export const PIVOT_ROWS: PivotRow[] = [
  { name: 'СГД (совокупный годовой доход)', level: 0, vals: {
    dd: [1307311315, 1307311000],
    sd: [842560000, 842560000],
    kl: [318420000, 318420000],
    ki: [612480500, 612400000],
    dk: [1024870000, 1024870000],
    cn: [186420000, 186420000],
  } },
  { name: '  Доход от реализации', level: 1, vals: {
    dd: [1284071000, 1284071000],
    sd: [820140000, 820140000],
    kl: [310200000, 310200000],
    ki: [598080500, 598080000],
    dk: [1010050000, 1010050000],
    cn: [180000000, 180000000],
  } },
  { name: '  Доход от прироста стоимости', level: 1, vals: {
    dd: [8420000, 8420000],
    sd: [12100000, 12100000],
    kl: [4220000, 4220000],
    ki: [8400000, 8320000],
    dk: [9820000, 9820000],
    cn: [4220000, 4220000],
  } },
  { name: '  Прочие доходы', level: 1, vals: {
    dd: [14820315, 14820000],
    sd: [10320000, 10320000],
    kl: [4000000, 4000000],
    ki: [6000000, 0],
    dk: [5000000, 5000000],
    cn: [2200000, 2200000],
  } },
  { name: 'Себестоимость', level: 0, vals: {
    dd: [-842145200, -842000000],
    sd: [-512680000, -512680000],
    kl: [-198420000, -198420000],
    ki: [-401280000, -401280000],
    dk: [-642100000, -642100000],
    cn: [-92840000, -92840000],
  } },
  { name: 'Валовая прибыль', level: 0, vals: {
    dd: [465166115, 465311000],
    sd: [329880000, 329880000],
    kl: [120000000, 120000000],
    ki: [211200500, 211120000],
    dk: [382770000, 382770000],
    cn: [93580000, 93580000],
  } },
  { name: 'Административные расходы', level: 0, vals: {
    dd: [-127480350, -127480350],
    sd: [-94200000, -94200000],
    kl: [-52800000, -52800000],
    ki: [-72400000, -72400000],
    dk: [-118600000, -118600000],
    cn: [-32400000, -32400000],
  } },
  { name: 'Расходы на реализацию', level: 0, vals: {
    dd: [-38240000, -38240000],
    sd: [-22100000, -22100000],
    kl: [-12400000, -12400000],
    ki: [-18900000, -18900000],
    dk: [-32400000, -32400000],
    cn: [-6200000, -6200000],
  } },
  { name: 'Прочие расходы', level: 0, vals: {
    dd: [-8120000, -8120000],
    sd: [-4200000, -4200000],
    kl: [-2100000, -2100000],
    ki: [-3600000, -3600000],
    dk: [-6400000, -6400000],
    cn: [-1400000, -1400000],
  } },
  { name: 'Расходы по вознаграждениям', level: 0, override: ['dd'], vals: {
    dd: [-12480000, -12480000],
    sd: [-8200000, -8200000],
    kl: [-4400000, -4400000],
    ki: [-6800000, -6800000],
    dk: [-10100000, -10100000],
    cn: [-1800000, -1800000],
  } },
  { name: 'Прибыль до налогообложения', level: 0, vals: {
    dd: [278845765, 278990650],
    sd: [201180000, 201180000],
    kl: [48300000, 48300000],
    ki: [109500500, 109420000],
    dk: [215270000, 215270000],
    cn: [51780000, 51780000],
  } },
  { name: 'КПН (20%)', level: 0, vals: {
    dd: [-55769153, -55798130],
    sd: [-40236000, -40236000],
    kl: [-9660000, -9660000],
    ki: [-21900100, -21884000],
    dk: [-43054000, -43054000],
    cn: [-10356000, -10356000],
  } },
  { name: 'Чистая прибыль', level: 0, total: true, vals: {
    dd: [223076612, 223192520],
    sd: [160944000, 160944000],
    kl: [38640000, 38640000],
    ki: [87600400, 87536000],
    dk: [172216000, 172216000],
    cn: [41424000, 41424000],
  } },
];

export const totalsRow = (row: PivotRow): [number, number] => {
  const calcs = COMPANIES.map((c) => row.vals[c.id][0]);
  const masters = COMPANIES.map((c) => row.vals[c.id][1]);
  return [
    calcs.reduce((a, b) => a + b, 0),
    masters.reduce((a, b) => a + b, 0),
  ];
};

export const cellStatus = (
  calc: number,
  master: number | null | undefined,
  override?: boolean
): 'over' | 'none' | 'match' | 'diff' => {
  if (override) return 'over';
  if (master === null || master === undefined) return 'none';
  if (Math.abs(calc - master) < 0.5) return 'match';
  return 'diff';
};
